export default __webpack_public_path__ + "static/media/fb.c1a637e8.svg";